import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { POST_PDF, CLEAR_RESULTS } from './constants';
import { postPdfSaga } from './sagas';

export const postPdf = (data, onSuccess, onUploadError) => {
  return createAction({
    type: POST_PDF,
    payload: data,
    meta: { onSuccess, onUploadError, async: postPdfSaga },
  });
};

export const clearResults = () => {
  return createAction({
    type: CLEAR_RESULTS,
  });
};
